import { render } from "./ProduktDetail.vue?vue&type=template&id=6afd5057"
import script from "./ProduktDetail.vue?vue&type=script&lang=js"
export * from "./ProduktDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/tristobombo/PHPStormProjects/ITW-webapp-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__